
































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util';
import AbpBase from '../../../lib/abpbase';
import Role from '@/store/entities/role';
import * as proxy from '@/lib/service-proxies/service-proxies';
@Component
export default class EditRole extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  role: Role = new Role();
  checktree: any = [];
  permissions: any = [];
  tempdatapermissions = [];
  DeepCopy(source: Object): any {
    if (null == source || {} == source || [] == source) {
      return source;
    }

    let newObject: any;
    let isArray = false;
    if ((source as any).length) {
      newObject = [];
      isArray = true;
    } else {
      newObject = {};
      isArray = false;
    }

    for (let key of Object.keys(source)) {
      if (null == source[key]) {
        if (isArray) {
          newObject.push(null);
        } else {
          newObject[key] = null;
        }
      } else {
        let sub =
          typeof source[key] == 'object'
            ? this.DeepCopy(source[key])
            : source[key];
        if (isArray) {
          newObject.push(sub);
        } else {
          newObject[key] = sub;
        }
      }
    }
    return newObject;
  }
  selectchanged(ev) {
    //重新设置选中的权限
    this.role.grantedPermissions = [];
    this.role.dataGrantedPermissionNames = [];
    this.getAllCheckPwoer(this.permissions);
  }
  //获取所有选中的权限
  getAllCheckPwoer(permission: any) {
    for (var i = 0; i < permission.length; i++) {
      if (permission[i].checked) {
        this.role.grantedPermissions.push(permission[i].name);
      }
      if (
        Array.isArray(permission[i].children) &&
        permission[i].children.length > 0
      ) {
        this.getAllCheckPwoer(permission[i].children);
      }
    }
  }
  getAllDataCheckPwoer(permission: any) {
    for (var i = 0; i < permission.length; i++) {
      if (permission[i].checked) {
        this.role.dataGrantedPermissionNames.push(permission[i].name);
      }
      if (
        Array.isArray(permission[i].children) &&
        permission[i].children.length > 0
      ) {
        this.getAllDataCheckPwoer(permission[i].children);
      }
    }
  }
  save() {
    this.role.dataGrantedPermissionNames = [];
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: 'role/update',
          data: this.role
        });
        (this.$refs.roleForm as any).resetFields();
        this.$emit('save-success');
        this.$emit('input', false);
      }
    });
  }
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit('input', false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value);
    } else {
      this.role = Util.extend(true, {}, this.$store.state.role.editRole);
       
      this.permissions = Util.extend(
        true,
        [],
        this.$store.state.role.permissions
      );
      for (var i = 0; i < this.role.grantedPermissions.length; i++) {
        this.setpowercheck(this.permissions, this.role.grantedPermissions[i]);
      }
    }
  }
  setpowercheck(permission: any, permissionName: string) {
    for (var i = 0; i < permission.length; i++) {
      if (permission[i].children == undefined) {
        permission[i].children = [];
      }
      if (
        permission[i].name == permissionName &&
        permission[i].children.length == 0
      ) {
        permission[i].checked = true;
      } else {
        if (permission[i].children.length > 0) {
          this.setpowercheck(permission[i].children, permissionName);
        }
      }
    }
  }
  toTree(data) {
    let result = [];
    if (!Array.isArray(data)) {
      return result;
    }
    data.forEach(item => {
      item.title = item.displayName;
      item.expand = true;
      item.children = [];
      delete item.children;
    });
    let map = {};
    data.forEach(item => {
      map[item.name] = item;
    });
    data.forEach(item => {
      let parent = map[item.parentName];
      if (parent) {
        (parent.children || (parent.children = [])).push(item);
      } else {
        result.push(item);
      }
    });
    return result;
  }
  roleRule = {
    name: [
      {
        required: true,
        message: this.L('FieldIsRequired', undefined, this.L('RoleName')),
        trigger: 'blur'
      }
    ],
    displayName: [
      {
        required: true,
        message: this.L('FieldIsRequired', undefined, this.L('DisplayName')),
        trigger: 'blur'
      }
    ]
  };
}
